import { Injectable } from '@angular/core';
import {
  DB_PROVIDER,
  LOGIN_OPTIONS,
  OPENID_PROVIDER,
  POLICY_OPTIONS,
  WHITE_LIST,
  SSO_PROVIDERS,
  rootDn,
  setEntities,
  setTableFields,
  JWS_PROVIDER
} from '@wms/settings/security';
import { WmHttpService, ProjectService } from '@wms/app/services';
import { environment } from "@wms/app";
import {filter, find, forEach, get, groupBy, includes, isArray, isEqual, map, pullAt, replace} from 'lodash-es';
import { getStudioUrl } from '@wms/app/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { param } from 'jquery';

@Injectable({
  providedIn: 'root'
})
export class SecurityService {
  isOpenIdProviderDisabled: boolean = false;
  xssConfig: any;
  _rolesConfig: any;
  _generalOptions: any;
  _authInfo: any;
  _interceptUrls: any;
  _serviceMap: any;
  isXssConfigSet: boolean;
  editorContent: any;
  configurationDetailsChanged: boolean;
  isUrlDirty: boolean;
  TARGET = 'Security';
  ALL_ACTIONS: any = ['REMOVE', 'VALIDATE', 'FILTER', 'TRUNCATE'];
  fieldNameColumns: any = ['unamePropertyName', 'uidPropertyName', 'pwPropertyName', 'rolePropertyName'];
  DEFAULT_DEMO_USERS: any = ['admin', 'user'];
  METADATA_FILE_PATH = '../project/src/main/resources/';
  METADATA_FILE_NAME = 'idpMetadata.xml';
  providers: any;
  hideMsg: boolean = true;
  messageService = {
    type: 'error',
    caption: ''
  }
  queryPlaceholder = '/*Please choose User Table and Username to autopopulate query*/';
  API_META: any = {
    getMethods: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/services/securityService/operations",
      method: "GET"
    },
    getGeneralOptions: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/general",
      method: "GET"
    },
    setGeneralOptions: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/general",
      method: "POST"
    },
    getAuthInfo: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/authInfo",
      method: "GET"
    },
    setAuthInfo: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/authInfo",
      method: "POST"
    },
    configDemo: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/providers/demo",
      method: "POST"
    },
    getDemoOptions: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/providers/demo",
      method: "GET"
    },
    configDatabase: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/providers/database",
      method: "POST"
    },
    getDatabaseOptions: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/providers/database",
      method: "GET"
    },
    configAD: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/providers/activedirectory",
      method: "POST"
    },
    getADOptions: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/providers/activedirectory",
      method: "GET"
    },
    configLDAP: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/providers/ldap",
      method: "POST"
    },
    getLDAPOptions: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/providers/ldap",
      method: "GET"
    },
    testLDAPConnection: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/providers/ldap/testconnection",
      method: "POST"
    },
    getCASOptions: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/providers/cas",
      method: "GET"
    },
    configCAS: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/providers/cas",
      method: "POST"
    },
    getSAMLOptions: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/providers/saml",
      method: "GET"
    },
    configSAML: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/providers/saml",
      method: "POST"
    },
    loadIdpMetadata: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/providers/saml/loadidpmetadata?idpMetadataUrl=:idpMetadataUrl",
      method: "GET",
      spinnerInfo: {
        showSpinner: false
      }
    },
    uploadIdpMetadata: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/providers/saml/loadidpmetadata",
      method: "POST"
    },
    getOpenIdOptions: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/providers/openId",
      method: "GET"
    },
    configOpenId: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/providers/openId",
      method: "POST"
    },
    getDefaultProviders: {
      url: environment.SERVICES_BASE_PATH + "services/openid/providers/default",
      method: "GET"
    },
    configCustomAuth: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/providers/customauth",
      method: "POST"
    },
    getCustomAuthOptions: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/providers/customauth",
      method: "GET"
    },
    getPortMapping: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/portmapping",
      method: "GET"
    },
    getSecurityInterceptURLs: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/intercepturls",
      method: "GET"
    },
    setSecurityInterceptURLs: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/intercepturls",
      method: "POST"
    },
    getRoles: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/roles",
      method: "GET"
    },
    setRoles: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/roles",
      method: "POST"
    },
    getRolesConfig: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/rolesconfig",
      method: "GET"
    },
    setRolesConfig: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/rolesconfig",
      method: "POST"
    },
    generateConfig: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/generateconfig",
      method: "POST"
    },
    appLogin: {
      url: "j_spring_security_check",
      method: "POST",
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    },
    appLogout: {
      url: "j_spring_security_logout",
      method: "POST"
    },
    getLoggedInUser: {
      url: environment.SERVICES_BASE_PATH + "services/security/user",
      method: "GET"
    },
    getConfig: {
      url: environment.SERVICES_BASE_PATH + "services/security/info",
      method: "GET"
    },
    getMobileConfig: {
      url: "metadata/app/security-config.json",
      method: "GET"
    },
    configCustomSecurity: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/providers/customauth",
      method: "POST"
    },
    getCustomSecurityConfig: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/providers/customauth",
      method: "GET"
    },
    testADConnection: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/providers/ad/testconnection",
      method: "POST"
    },
    getPolicyConfig: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/xss/policy",
      method: "GET"
    },
    setPolicyConfig: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/securityservice/xss/policy",
      method: "PUT"
    }
  };
  QUERY_TYPES: any = {
    NATIVE_SQL: 'NATIVE_SQL',
    SQL: 'SQL',
    HQL: 'HQL'
  };

  securityProps: any = {
    dbSchemas: [],
    columnFieldMap: {},
    fieldColumnMap: {},
    tableEntityMap: {},
    servicesArray: [],
    servicesUrlMap: {},
    servicesMapCopy: {},
    currentServicePermissions: {},
    relations: {},
    handlers: {},
    prevProvider: '',
    curPerTab: 'web',
    message: null,
    isLoading: false,
    spinnerMsg: ''
  };
  SUBJECT_NAME: any;
  openId: any = {
    _selectModel: ''
  };
  selectedJswProviderName:string;

  sslFormInitialValue: any;
  safeguardsFormInitialValue: any;
  truststoreFormInitialValue: any;
  csrfFormInitialValue: any;
  loginFormInitialValue: any;
  databaseFormInititalValue: any = {
    Database : {},
    LDAP: {},
    AD : {},
    CAS : {},
    SAML : {},
    OpenId : {}
  };
  ldapFormInitialValue: any;
  adFormInitialValue: any;
  casFormInitialValue: any;
  jwsFormInitialValue: any;
  opaqueFormInitialValue: any;
  samlFormInitialValue: any;
  customFormInitialValue: any;
  openIdInitalValue: any;

  //dialog namespace (with default options)
  security: any = {
    enableSecurityProvider: false,
    enableSecurity: false,
    login: {
      type: LOGIN_OPTIONS.PAGE,
      sessionTimeout: {
        type: LOGIN_OPTIONS.DIALOG
      },
      sessionConcurrencyConfig: {
        maxSessionsAllowed: -1
      },
    },
    sslConfig: {
      useSSL: false
    },
    provider: 'Demo',
    custom: {},
    dirtyCheckList: [],
    tagRules: {},
    xFrameOptions: [{ 'label': 'Deny', 'value': 'DENY' },
    { 'label': 'Same Origin', 'value': 'SAMEORIGIN' },
    { 'label': 'Allow From', 'value': 'ALLOW_FROM' }],
    sessionPersistenceConfig: {
      enabledType: 'IN_MEMORY',
      config: {
        REDIS: {
          hostName: '',
          port: '',
          database: '0',
          password: '',
          type: 'REDIS'
        },
        JDBC: {
          serviceName: '',
          type: 'JDBC'
        },
        MONGODB: {
          host: '',
          port: '',
          username: '',
          password: '',
          dbname: '',
          type: 'MONGODB'
        }
      }
    },
    trustStoreConfig: {
    trustStoreConfigType: "",
     file: "",
     fileType: "",
     password: ""
    },
    mtlsConfig: {
     enabled: false,
     file: "",
     fileType: "",
     password: ""
    },
    clientSSLHostNameVerificationEnabled: false
  };
  demoUsers: any = [
    {
      'username': 'user',
      'password': 'user',
      'roles': ['user']
    },
    {
      'username': 'admin',
      'password': 'admin',
      'roles': ['admin']
    }
  ];
  resetForm = new Subject();
  populateQuery = new Subject();
  populateDynamicQuery = new BehaviorSubject('');
  updateOpenIdProviderId = new BehaviorSubject<string>('');
  updateJwsProviderId = new BehaviorSubject<string>('');
  constructor(private wmHttpService: WmHttpService, private projectService: ProjectService) {
    this.wmHttpService.registerApiMeta(this.TARGET, this.API_META);
    this.SUBJECT_NAME = 'cn=' + this.projectService.getDetails().name + ', OU=WM, O=WM, L=LA, ST=CA, C=US';
  }

  setServices(serviceMap: any) {
    this._serviceMap = serviceMap;
  }

  /**
   * @ngdoc function
   * @name wm.security.$SecurityService#getSecurityInterceptURLs
   * @methodOf wm.security.$SecurityService
   * @function
   *
   * @description
   * The API is used to get the security intercept url list of the application. These url’s determines the authentication or validation for the urls. This data is retrieved from project-security.xml file under <security:http> tag. In the xml file the entry for security intercept url looks like this:
   * <security:intercept-url pattern="/app.css" access="permitAll"/>
   * where pattern attribute refers to the url pattern and access attribute refers to the authentication level.
   * Also note that there are default 15 url present in the xml file which is entered automatically on enabling security for the first time. Also, it is important to enable security before executing this API otherwise the API will throw an exception.
   *
   */

  getSecurityInterceptURLs() {
    if (this._interceptUrls === undefined) {
      return this.wmHttpService.execute({
        target: 'Security',
        action: 'getSecurityInterceptURLs',
        urlParams: {
          projectID: this.projectService.getProjectId()
        }
      });
    } else {
      return Promise.resolve(this._interceptUrls);
    }

  }
  getUpdateOpenIdProviderId() {
    return this.updateOpenIdProviderId.asObservable();
  }
  notifyUpdateOpenIdProviderId(selectedProvider: string) {
    this.updateOpenIdProviderId.next(selectedProvider);
  }
  public getUpdateJwsProviderId() {
    return this.updateJwsProviderId.asObservable();
  }
  public notifyUpdateJwsProviderId(selectedProvider: string) {
    this.updateJwsProviderId.next(selectedProvider);
  }

  toggleRoleMapping(value: boolean) {
    this.security.roleMappingEnabled = value;
  }

  /**
   * @ngdoc function
   * @name wm.security.$SecurityService#getDefaultProviders
   * @methodOf wm.security.$SecurityService
   * @function
   *
   * @description
   * The API is used to get the all the default providers.
   *
   */

  getDefaultProviders() {
    return this.wmHttpService.execute({
      target: 'Security',
      action: 'getDefaultProviders'
    });
  }

  showMessage (message: string,type: string): void {
    this.messageService ={
      caption: message,
      type: type
    }
  }
  hideMessage(hideMessage: boolean){
    this.hideMsg = hideMessage
  }

  setRoleConfig(options: any) {
    this.security.roleConfig = options.useRolesQuery ? 'CUSTOM' : 'BASIC';
    /**Support for old and new projects
     * Default               : HQL
     * In case of HQL        : HQL
     * In case of NATIVE_SQL : SQL(Old Projects)  NATIVE_SQL(New Projects)**/
    this.security.queryType = options.queryType && options.queryType !== this.QUERY_TYPES.HQL ? this.QUERY_TYPES.NATIVE_SQL : this.QUERY_TYPES.HQL;
  };

  /**
   * @ngdoc function
   * @name wm.security.$SecurityService#getAuthInfo
   * @methodOf wm.security.$SecurityService
   * @function
   *
   * @description
   * The API is used to get values of authentication options. These values can determine if security config is enabled or not and also stores the type of datasource to be used. Following are the fields associated in generaloptions object:
   * 1. enforceSecurity - it signifies whether security is enabled or not for the associated project.
   * 2. csrfConfig - it signifies whether csrf security enabled or not and headerName
   * 3. loginConfig - it signifies type,pageName and sessionTimeout
   * 4. rememberMeConfig - it signifies whether rememberMeConfig enabled or not and tokenValiditySeconds.
   * 5.tokenAuthConfig - it signifies whether tokenAuthConfig enabled or not, parameter and tokenValiditySeconds.
   * 6. authProviders - Its a set containing the Security AUth providers in use. Each element can have one of the following values
   *      - DEMO
   *      - DATABASE
   *      - LDAP
   *      -SAML
   *      -Open ID
   *      - AD
   *      - CAS
   *      - CUSTOM
   *
   */

  getAuthInfo(reloadFlag?: any) {
    if (this._authInfo && !reloadFlag) {
      return Promise.resolve(this._authInfo);
    } else {
      return (this.wmHttpService.execute({
        target: "Security",
        action: "getAuthInfo",
        pathParams: {
          projectID: this.projectService.getProjectId()
        }
      }) as Promise<any>).then((authInfo: any) => {
        this._authInfo = authInfo;
        return Promise.resolve(this._authInfo);
      });
    }
  }

  /**
   * @ngdoc function
   * @name wm.security.$SecurityService#testLDAPConnection
   * @methodOf wm.security.$SecurityService
   * @function
   *
   * @description
   * The API is used to test the LDAP Connection whether it is valid and working or not. To do this, a requestBody is set with LDAPOption object which contains connection detail.
   *
   * @param {object} params object containing parameters for the request
   */

  testLDAPConnection(params: any) {
    return this.wmHttpService.execute({
      target: 'Security',
      action: 'testLDAPConnection',
      urlParams: {
        projectID: this.projectService.getProjectId()
      },
      data: params.config
    });
  }

  /**
   * @ngdoc function
   * @name wm.security.$SecurityService#testADConnection
   * @methodOf wm.security.$SecurityService
   * @function
   *
   * @description
   * The API is used to test the AD(Active Directory) Connection whether it is valid and working or not.
   * To do this, a requestBody is set with ADOption object which contains connection detail.
   *
   * @param {object} params object containing parameters for the request
   */
  testADConnection(params: any) {
    return this.wmHttpService.execute({
      target: 'Security',
      action: 'testADConnection',
      urlParams: {
        projectID: this.projectService.getProjectId()
      },
      data: params.config
    });
  }


  /**
   * @ngdoc function
   * @name wm.security.$SecurityService#uploadIdpMetadata
   * @methodOf wm.security.$SecurityService
   * @function
   *
   * @description
   * The uploaded xml file configures SAML as the service provider.
   * Configuration parameters should be sent through json object using RequestBody.
   *
   * This call is a multipart data request. Metadata file should be sent in the request body.
   *
   * @param {object} params object containing parameters for the request
   */

  uploadIdpMetadata(params: any) {
    return this.wmHttpService.execute({
      target: 'Security',
      action: 'uploadIdpMetadata',
      urlParams: {
        projectID: this.projectService.getProjectId()
      },
      data: params.content
    });
  }

  /**
   * @ngdoc function
   * @name wm.security.$SecurityService#loadIdpMetadata
   * @methodOf wm.security.$SecurityService
   * @function
   *
   * @description
   * Loads SAML metadata through MetadataUrl.
   *
   * Url Parameters
   * 1) Project ID
   * 2) IDP Metadata URL
   *
   * @param {object} params object containing parameters for the request
   */

  loadIdpMetadata(params: any) {
    return this.wmHttpService.execute({
      target: 'Security',
      action: 'loadIdpMetadata',
      urlParams: {
        projectID: this.projectService.getProjectId(),
        idpMetadataUrl: params.idpMetadataUrl
      }
    });
  }

  /**
   * @ngdoc function
   * @name wm.security.$SecurityService#getRolesConfig
   * @methodOf wm.security.$SecurityService
   * @function
   *
   * @description
   * The API is used to retrieve the role config landing page details.
   * This configuration defines the landing page configurations for each role. User will be re-directed
   * to the landing page configured for the user's specific role.
   *
   * @param {string} projectID project id
   * @param {function} successCallback to be called on success
   * @param {function} failureCallback to be called on failure
   */

  getRolesConfig(reloadFlag?: any) {
    if (this._rolesConfig && !reloadFlag) {
      return Promise.resolve(this._rolesConfig);
    } else {
      return (this.wmHttpService.execute({
        target: "Security",
        action: "getRolesConfig",
        pathParams: {
          projectID: this.projectService.getProjectId()
        }
      }) as Promise<any>).then((rolesConfig: any) => {
        this._rolesConfig = rolesConfig;
        return Promise.resolve(this._rolesConfig);
      });
    }
  }

  /**
   * @ngdoc function
   * @name wm.security.$SecurityService#getGeneralOptions
   * @methodOf wm.security.$SecurityService
   * @function
   *
   * @description
   * The API is used to get values of general options. These values can determine if security config is enabled or not and also stores the type of datasource to be used. Following are the fields associated in generaloptions object:
   * 1. enforceSecurity - it signifies whether security is enabled or not for the associated project.
   * 2. enforceIndexHtml - it signifies whether default login or custom login page to be used.
   * 3. useSSL - it depicts whether secure socket layer to be used or not.
   * 4. sslPort - if useSSL is true then the value of this parameter to be used. This is invalid in SaaS.
   * 5. authProviders - Its a set containing the Security AUth providers in use. Each element can have one of the following values
   *      - DEMO
   *      - DATABASE
   *      - LDAP
   *      - AD
   *      - CAS
   *      - CUSTOM
   *
   */

  getGeneralOptions(reloadFlag: boolean): any {
    if (this._generalOptions && !reloadFlag) {
      return Promise.resolve(this._generalOptions);
    } else {
      return this.wmHttpService.execute({
        target: 'Security',
        action: 'getGeneralOptions',
        pathParams: {
          projectID: this.projectService.getProjectId()
        }
      });
    }
  }

  /**
   * @ngdoc function
   * @name wm.security.$SecurityService#getPolicyConfig
   * @methodOf wm.security.$SecurityService
   * @function
   *
   * @description
   * get the policy config
   */
  getPolicyConfig() {
    return this.wmHttpService.execute({
      target: 'Security',
      action: 'getPolicyConfig',
      pathParams: {
        projectID: this.projectService.getProjectId()
      }
    });
  }

  /**
   * @ngdoc function
   * @name wm.security.$SecurityService#setGeneralOptions
   * @methodOf wm.security.$SecurityService
   * @function
   *
   * @description
   * to store the general Options of the security in this service
   *
   * @param {object} generalOptions general options
   */

  setGeneralOptions(params: any) {
    return (this.wmHttpService.execute({
      target: 'Security',
      action: 'setGeneralOptions',
      urlParams: {
        projectID: this.projectService.getProjectId()
      },
      data: params.config
    }) as Promise<any>).then(() => {
      this._generalOptions = params.config;
    });
  }

  /**
   * @ngdoc function
   * @name wm.security.$SecurityService#setAuthInfo
   * @methodOf wm.security.$SecurityService
   * @function
   *
   * @description
   * to store the authentication information of the security in this service
   *
   * @param {object} Authentication information
   */

  setAuthInfo(params: any) {
    return (this.wmHttpService.execute({
      target: 'Security',
      action: 'setAuthInfo',
      urlParams: {
        projectID: this.projectService.getProjectId()
      },
      data: params.config
    }) as Promise<any>).then(() => {
      this._authInfo = params.config;
      return Promise.resolve();
    });
  }

  cacheGeneralOptions(generalOptions: any) {
    this._generalOptions = generalOptions;
  }

  saveRolesConfig() {
    // once roles config is set, do not set the roles config again by removing roles from dirtyCheckList
    this.security.dirtyCheckList.splice(this.security.dirtyCheckList.indexOf('roles'), 1);
    //set roles config
    return (this.wmHttpService.execute({
      target: 'Security',
      action: 'setRolesConfig',
      urlParams: {
        projectID: this.projectService.getProjectId()
      },
      data: this.security.roleConfigurations
    }) as Promise<any>).then(() => this._rolesConfig = this.security.roleConfigurations);
  }

  /**
   * @ngdoc function
   * @name wm.security.$SecurityService#setSecurityInterceptURLs
   * @methodOf wm.security.$SecurityService
   * @function
   *
   * @description
   * The API is used to add security intercept urls in the project-security.xml file. The intercept url’s is used to authenticate url while its execution. When this api is executed an entry is made in <security:http> tag of project-security.xml file. The entry is as follows:
   * <security:intercept-url pattern="/app.css" access="permitAll"/>
   * where pattern attribute refers to the url pattern and access attribute refers to the authentication level.
   * During calling this api, a RequestBody object has to be set which consist of general options and securityURLMap. SecurityURLMap accepts pattern and access as its key value pair. Please see example for more detail.
   *
   * @param {object} params object containing parameters for the request
   */

  setSecurityInterceptURLs(params: any) {
    return (this.wmHttpService.execute({
      target: 'Security',
      action: 'setSecurityInterceptURLs',
      urlParams: {
        projectID: this.projectService.getProjectId()
      },
      data: params.config
    }) as Promise<any>).then(() => {
      this._interceptUrls = params.config;
    });
  }

  //get the options for Demo security provider from backend
  getDemoOptions(authInfo: any, isRoleDeleted?: any) {
    this.security.rememberMeConfig = authInfo.rememberMeConfig;
    this.security.demoUsers = [];
    let demoProvider: any = find(authInfo.authProviders, { type: 'DEMO' });
    if(demoProvider) {
      this.security.enableSecurityProvider = demoProvider.enabled;
    }
    let users: any = demoProvider ? demoProvider.users : [];
    users = users.length ? users : this.demoUsers;
    forEach(users, (user) => {
      /*dissociating deleted roles with the demo users in the setup tab. if role is deleted then
        * remove the roles from user associations and update the user roles*/
      user.roles = isRoleDeleted ? this.removeRolesFromDemoOptions(user.roles, this.security.roles) : user.roles;
      let userName = user.userid || user.username,
        userObj: any = {
          username: userName,
          password: user.password,
          roles: user.roles
        };
      if (includes(this.DEFAULT_DEMO_USERS, userName)) {
        userObj.isDefault = true;
      }
      this.security.demoUsers.push(userObj);
    });
  }

  //function to remove user roles after they have been deleted from the security roles
  removeRolesFromDemoOptions(userRoles: any, securityRoles: any) {
    let secRoleIndex = 0,
      userRoleIndex = 0;
    for (secRoleIndex = 0; secRoleIndex < securityRoles.length; secRoleIndex++) {
      for (userRoleIndex = 0; userRoleIndex < userRoles.length; userRoleIndex++) {
        //if user selected role is not available in the security roles then remove it
        if (securityRoles.indexOf(userRoles[userRoleIndex]) === -1) {
          pullAt(userRoles, userRoleIndex);
          break;
        }
      }
    }
    return userRoles;
  }

  //Intialize tag Rules
  fetchTagRules(event?: any, isEventChanged: boolean = false) {
    if (isEventChanged) {
      this.security.policyType = event === true ? POLICY_OPTIONS.MANUAL : POLICY_OPTIONS.IMPORT;
    }
    if (this.security.xssFilterStrategy === WHITE_LIST) {
      // TODO
      // this.showSpinner();
      (this.getPolicyConfig() as Promise<any>).then((policyConfig) => {
        // TODO
        // this.hideSpinner();
        let rules = policyConfig.tagRules;
        //Categorise rules based on action
        rules = groupBy(rules, 'action');
        forEach(this.ALL_ACTIONS, (action) => {
          this.security.tagRules[action] = map(rules[action], (tag) => {
            return tag.name;
          });
        });
        this.security.tagRules.unknownTag = policyConfig.unknownTagAction;
      });
    }
  }

  /**
   * @ngdoc function
   * @name wm.security.$SecurityService#setPolicyConfig
   * @methodOf wm.security.$SecurityService
   * @function
   *
   * @description
   * set the policy config
   *
   * @param {object} params object containing parameters for the request
   */
  setPolicyConfig(params: any) {
    return (this.wmHttpService.execute({
      target: 'Security',
      action: 'setPolicyConfig',
      urlParams: {
        projectID: this.projectService.getProjectId()
      },
      data: params.config
    }) as Promise<any>);
  }

  //set xss config
  initXSSConfig(xssConfig: any) {
    if (!this.isXssConfigSet) {
      //If the response is not set register a event
      // TODO
      // let deregister = this.$on('wms:init-policy-config', function (e, data) {
      //     //deregister handler event since it is called only once
      //     deregister();
      //     initXSSConfig(data);
      // });
    }

    if (xssConfig) {
      this.security.xssFilterStrategy = replace(xssConfig.xssFilterStrategy, '_', ' ');
      this.security.policyType = xssConfig.policyType || POLICY_OPTIONS.IMPORT;
      this.security.policyFile = xssConfig.policyFile;
      this.security.xssSanitizationLayer = xssConfig.xssSanitizationLayer;
      this.fetchTagRules();
    }
  }

  //clear the pre-populated fields in UI
  resetConfig() {
    this.security.url = null;
    this.security.userDnPattern = null;
    this.security.groupSearchBase = null;
    this.security.testUsername = null;
    this.security.testPassword = null;
    this.security.managerDn = null;
    this.security.managerPassword = null;
  }

  //clear the pre-populated fields in UI
  resetOpenIdConfig() {
    this.security.providerId = null;
    this.security.clientId = null;
    this.security.clientSecret = null;
    this.security.authorizationUrl = null;
    this.security.tokenUrl = null;
    this.security.jwkSetUrl = null;
    this.security.userInfoUrl = null;
    this.security.logoutUrl = null;
    this.security.scopes = null;
    this.security.userNameAttributeName = null;
  }

  resetSAMLConfig(internalReset?: boolean) {
    if (!internalReset) {
      this.security.idpMetadataUrl = '';
      this.isUrlDirty = false;
    }
    this.security.idpPublicKey = '';
    this.security.metadataFileName = '';
    this.security.idpEndpointUrl = '';
    this.security.keyStoreName = '';
    this.security.keyAlias = '';
    this.security.keyStorePassword = '';
    this.security.maxAuthenticationAge = 7200;
    this.security.roleMappingEnabled = false;
    this.security.roleMappingConfig = {};
  }

  // gets Open id options and updates the open id properties.
  getOpenIdOptions(authInfo: any) {
    this.providers = [];

    this.resetOpenIdConfig();
    this.resetRoleMappingConfig();
    let availableProviders = filter(authInfo.authProviders,(provider) => provider.type === 'OPENID');
    let isDefaultProviderAvailable = find(availableProviders, { providerId: 'google' });
    this.providers = [...availableProviders];
    this.providers.push({ providerId: 'custom' });
    if(!isDefaultProviderAvailable) {
      if(this.security.defaultProviderGoogle) {
        this.providers.unshift(this.security.defaultProviderGoogle);
      }
      else {
        (this.getDefaultProviders() as Promise<any>).then(defaultProvider => {
          this.providers.unshift(...defaultProvider);
          this.security.defaultProviderGoogle = defaultProvider[0];
        })
      }
    }

    if(availableProviders && availableProviders.length > 0) {
      let selectedProviderOptions: any = availableProviders[0];
      if(selectedProviderOptions.providerId === 'google' && selectedProviderOptions.clientId === '') {
         if(availableProviders.length > 1) {
           selectedProviderOptions = availableProviders[1];
         }
      }
      this.security.enableSecurityProvider = selectedProviderOptions.enabled;
      this.security.providerId = selectedProviderOptions.providerId;
      this.security.clientId = selectedProviderOptions.clientId;
      this.security.clientSecret = selectedProviderOptions.clientSecret;
      this.security.authorizationUrl = selectedProviderOptions.authorizationUrl;
      this.security.tokenUrl = selectedProviderOptions.tokenUrl;
      this.security.jwkSetUrl = selectedProviderOptions.jwkSetUrl;
      this.security.userInfoUrl = selectedProviderOptions.userInfoUrl;
      this.security.logoutUrl = selectedProviderOptions.logoutUrl;
      this.security.scopes = isArray(selectedProviderOptions.scopes) ? selectedProviderOptions.scopes.join(', ') : selectedProviderOptions.scopes;
      this.security.userNameAttributeName = selectedProviderOptions.userNameAttributeName;
      this.toggleRoleMapping(selectedProviderOptions.roleMappingEnabled);
      if (selectedProviderOptions.roleMappingEnabled) {
        let roleMappingOptions = selectedProviderOptions.roleMappingConfig;
        if (!roleMappingOptions.modelName) {
          this.security.roleProvider = OPENID_PROVIDER.id;
          this.security.roleAttributeName = roleMappingOptions.roleAttributeName;
        } else {
          this.security.roleProvider = DB_PROVIDER.id;
          this.setDBConfiguration(roleMappingOptions)
        }
      }
    }
    this.changeRedirectUrlURL();

  }

  changeRedirectUrlURL() {
    this.security.redirectUrlTemplate = getStudioUrl() + '/oauth2/code/' + (this.security.providerId || '{providerId}');
  }

  getSAMLOptions(authInfo: any) {
    this.resetSAMLConfig();
    this.resetRoleMappingConfig()
    this.security.rememberMeConfig = authInfo.rememberMeConfig;
    let options = find(authInfo.authProviders, (provider) => provider.type === 'SAML');
    if (options) {
      this.security.enableSecurityProvider = options.enabled;
      this.security.idpMetadataUrl = options.idpMetadataUrl;
      this.security.idpMetadataSource = options.idpMetadataSource || this.security.metadataSrcOptionsMap.URL;
      this.security.metadataFileName = options.idpMetadataSource === this.security.metadataSrcOptionsMap.FILE ? this.METADATA_FILE_NAME : undefined;
      this.security.idpPublicKey = options.idpPublicKey;
      this.security.idpEndpointUrl = options.idpEndpointUrl;
      this.security.createKeystore = options.createKeystore;
      this.security.keyStoreName = options.keyStoreName;
      this.security.keyAlias = options.keyAlias;
      this.security.keyStorePassword = options.keyStorePassword;
      this.security.subjectName = options.subjectName || this.SUBJECT_NAME;
      this.security.maxAuthenticationAge = options.maxAuthenticationAge;
      this.security.roleMappingEnabled = options.roleMappingEnabled;

      // set createKeystore to null if keystore name is not set
      /*TODO: This condition should be removed, should depend on the property which indicates whether the keystore is imported or autogenerated.*/
      if (options.keyStoreName === null) {
        this.security.createKeystore = null;
      }

      if (options.roleMappingEnabled) {
        options = options.roleMappingConfig;
        if (!options.modelName) {
          this.security.roleAttributeName = options.roleAttributeName;
          this.security.roleProvider = 'SAML';
        }else{
         this.security.roleProvider = 'Database';
         this.setDBConfiguration(options)
        }
      }
    }
  }

  getCASOptions(authInfo: any) {
    //clear the pre-populated fields in UI
    const resetConfig = () => {
      this.security.serverUrl = null;
      this.security.loginUrl = null;
      this.security.validationUrl = null;
      this.security.logoutUrl = null
    }
    resetConfig();
    this.resetRoleMappingConfig()
    this.security.rememberMeConfig = authInfo.rememberMeConfig;
    var options = find(authInfo.authProviders, (provider) => provider.type === 'CAS');
    if (options) {
      this.security.enableSecurityProvider = options.enabled;
      this.security.serverUrl = options.serverUrl;
      this.security.loginUrl = options.loginUrl;
      this.security.logoutUrl = options.logoutUrl;
      this.security.validationUrl = options.validationUrl;
      this.security.artifactParameter = options.artifactParameter || 'ticket';
      this.security.serviceParameter = options.serviceParameter || 'service';
      this.security.roleMappingEnabled = options.roleMappingEnabled;
      this.security.attributes = options.attributes;

      if (options.roleMappingEnabled) {
        options = options.roleMappingConfig;
        if (!options.modelName) {
          this.security.roleAttributeName = options.roleAttributeName;
          this.security.roleProvider = 'CAS';
        } else {
          this.security.roleProvider = 'Database';
          this.setDBConfiguration(options)
        }
      }
    }
  }
  getJWSOptions(authInfo: any) {
    //clear the pre-populated fields in UI
    const resetConfig = () => {
      this.security.providerId = null;
      this.security.issuerUrl = null;
      this.security.principalClaimName = null;
      this.security.roleMappingEnabled = false;
      this.security.roleMappingConfig = {};

    }
    resetConfig();
    this.resetRoleMappingConfig()
    this.security.rememberMeConfig = authInfo.rememberMeConfig;
  }

  getOpaqueOptions(authInfo: any) {
    //clear the pre-populated fields in UI
    const resetConfig = () => {
      this.security.introspectionUrl = null;
      this.security.clientId = null;
      this.security.principalClaimName = null;
      this.security.clientSecret = null
    }
    resetConfig();
    this.resetRoleMappingConfig()
    this.security.rememberMeConfig = authInfo.rememberMeConfig;
    var options = find(authInfo.authProviders, (provider) => provider.type === 'OPAQUE_TOKEN');
    if (options) {
      this.security.enableSecurityProvider = options.enabled;
      this.security.introspectionUrl = options.introspectionUrl;
      this.security.principalClaimName = options.principalClaimName;
      this.security.clientSecret = options.clientSecret;
      this.security.clientId = options.clientId;
      this.security.roleMappingEnabled = options.roleMappingEnabled;

      if (options.roleMappingEnabled) {
        options = options.roleMappingConfig;
        if (!options.modelName) {
          this.security.roleAttributeName = options.roleAttributeName;
          this.security.roleProvider = 'OPAQUE_TOKEN';
        } else {
          this.security.roleProvider = 'Database';
          this.setDBConfiguration(options)
        }
      }
    }
  }


  getActiveDirectoryOptions(authInfo: any) {
    //clear the pre-populated fields in UI
    const resetConfig = () => {
      this.security.domain = '';
      this.security.userDnPattern = null;
      this.security.url = null;
      this.security.managerDn = null;
      this.security.managerPassword = null;
      this.security.rootDn = null;
      this.security.adGroupRoleAttribute = null;
    }
    resetConfig();
    this.resetRoleMappingConfig()
    this.security.rememberMeConfig = authInfo.rememberMeConfig;
    let options = find(authInfo.authProviders, (provider) => provider.type === 'AD');
    this.security.adGroupRoleAttribute = get(options, 'groupRoleAttribute') || 'memberOf';
    if (options) {
      //make intial test connection mandatory
      if (!options.url) {
        this.configurationDetailsChanged = true;
      }
      this.security.enableSecurityProvider = options.enabled;
      this.security.domain = options.domain;
      this.security.url = options.url;
      this.security.managerDn = options.managerDn;
      this.security.rootDn = options.rootDn || rootDn(options.domain);
      this.security.managerPassword = options.managerPassword;
      this.security.userSearchPattern = options.userSearchPattern || '(&(objectClass=user)(userPrincipalName={0}))';
      this.security.roleMappingEnabled = options.roleMappingEnabled;
      // this.security.managerDn = '';
      // this.security.managerPassword = '';
      if (options.roleMappingEnabled) {
        options = options.roleMappingConfig;
        if (options.modelName) {
          this.security.roleProvider = 'Database';
          this.setDBConfiguration(options)
        } else {
          this.security.adGroupRoleAttribute = this.security.adGroupRoleAttribute;
          this.security.roleProvider = 'Active Directory';
        }
      }
    }
  }

  getCustomOptions(authInfo: any) {
    let custom = find(authInfo.authProviders, (provider) => provider.type === 'CUSTOM');
    if (custom) {
      this.security.enableSecurityProvider = custom.enabled;
      this.security.custom.authClassName = custom.fqCustomAuthenticationManagerClassName;
    }
  }

  //get the options for Database security provider from backend
  getDatabaseOptions(authInfo: any) {
    let options = find(authInfo.authProviders, (provider) => provider.type === 'DATABASE');
    let scopeObj: any = {
      security: this.security,
      securityProps: this.securityProps
    };
    this.resetRoleMappingConfig()
    let projectId = this.projectService.getProjectId();
    if (options && options.modelName) {
      setEntities(projectId, options.modelName, scopeObj, () => {
        setTableFields(projectId, options.modelName, options.tableName, scopeObj, () => {
          forEach(options, (value, key) => {
            if (includes(this.fieldNameColumns, key)) { //Re-mapping field names to property names
              value = this.securityProps.fieldColumnMap[value];
            }
            this.security[key] = value;
          });
          this.populateQuery.next('');
          this.security.roleQuery = options.rolesByUsernameQuery;
          this.populateDynamicQuery.next('');
        });
      });
      this.security.enableSecurityProvider = options.enabled;
      this.setRoleConfig(options);
      this.editorContent = options.rolesByUsernameQuery || this.queryPlaceholder;
    }
  }

  getLDAPOptions(authInfo: any) {
    this.resetConfig();
    this.resetRoleMappingConfig()
    this.security.rememberMeConfig = authInfo.rememberMeConfig;
    var options = find(authInfo.authProviders, (provider) => provider.type === 'LDAP');
    //make intial test connection mandatory
    if (options) {
      if (!options.url) {
        this.configurationDetailsChanged = true;
      }
      this.security.enableSecurityProvider = options.enabled;
      this.security.domain = options.domain;
      this.security.url = options.url;
      this.security.managerDn = options.managerDn;
      this.security.managerPassword = options.managerPassword;
      this.security.userDnPattern = options.userDnPattern;
      this.security.groupSearchBase = options.groupSearchBase;
      this.security.roleMappingEnabled = options.roleMappingEnabled;
      if (this.security.roleMappingEnabled) {
        options = options.roleMappingConfig;
        if (options && options.modelName) {
          this.security.roleProvider = 'Database';
          this.setDBConfiguration(options)
        } else {
          this.security.ldapGroupRoleAttribute = options.groupRoleAttribute || this.security.ldapGroupRoleAttribute;
          this.security.groupSearchFilter = options.groupSearchFilter || this.security.groupSearchFilter;
          this.security.roleProvider = 'LDAP';
        }
      }
    }
  }

  setDBConfiguration(roleMappingOptions:any){
    let scopeObj = {
      security : this.security,
      securityProps : this.securityProps
    };
    this.setRoleConfig(roleMappingOptions);
    let projectId = this.projectService.getProjectId();
    setEntities(projectId,roleMappingOptions.modelName, scopeObj, () => {
      if(this.security.roleConfig === 'BASIC'){
      setTableFields(projectId,roleMappingOptions.modelName, roleMappingOptions.tableName, scopeObj, () => {
          this.security.tableName          = roleMappingOptions.tableName;
          this.security.unamePropertyName  = this.securityProps.fieldColumnMap[roleMappingOptions.usernameField];
          this.security.rolePropertyName   = this.securityProps.fieldColumnMap[roleMappingOptions.roleField];
      });
      }
      this.security.modelName          = roleMappingOptions.modelName;
      this.security.useRolesQuery      = roleMappingOptions.useRolesQuery;
      this.security.queryType          = roleMappingOptions.queryType;
      this.security.roleQuery          = roleMappingOptions.roleQuery;
      this.editorContent = roleMappingOptions.roleQuery;
      this.populateDynamicQuery.next('');

    });
  }

  resetRoleMappingConfig(){
    this.security.modelName = '';
    this.security.useRolesQuery = false;
    this.security.queryType = this.QUERY_TYPES.HQL;
    this.security.roleQuery = null;
    this.security.tableName = null;
    this.security.unamePropertyName = null;
    this.security.rolePropertyName = null;
    this.security.roleConfig = 'BASIC'
    this.security.roleMappingEnabled = false
  }
  getEnabledProvidersCount(authInfo: any): number {
    let enabledCnt: number = 0;
    for(let provider of authInfo.authProviders) {
      if(provider.enabled) {
        enabledCnt++;
      }
    }
    return enabledCnt;
  }
  isSSO(authInfo?: any): boolean {
    if(authInfo){
      return authInfo.authProviders.length === 1 && includes(SSO_PROVIDERS, authInfo.authProviders[0].type);
    }
    return this._authInfo.authProviders.length === 1 && includes(SSO_PROVIDERS, this._authInfo.authProviders[0].type);
  }
}
